import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AttributeGroupModel, AttributeModel, attributePresetTypes, FileData, Lang, OrganizationReference, ReferenceParams, Res } from 'src/app/models';
import { ApiAttributesMappingService, DialogModalService, LanguageService, NotificationService, PermissionService, ValidatorsService } from 'src/app/services';
import { FileUploadProcessComponent } from '../../../files/file-upload-process/file-upload-process.component';
import { AttributesMappingActionsValidator } from './attributes-mapping-actions.validator';

@Component({
  selector: 'app-attributes-mapping-actions',
  templateUrl: './attributes-mapping-actions.component.html',
  styleUrls: ['./attributes-mapping-actions.component.css']
})
export class AttributesMappingActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  errorMessages: any;
  language: string;
  loading: boolean;
  mappingId: string;
  mappingData: any;
  attributes: AttributeModel[][] = [];
  attributeGroups: AttributeGroupModel[] = [];
  attributePresetTypes: attributePresetTypes[] = [];
  organizations: OrganizationReference[] = [];
  mappingName: Lang;
  multiple: boolean = false;
  component: string = 'import';
  file: string[] = [];
  deletedData: string[] = [];
  ffInputLang: any = { name: '', valid: false };
  isCollapsed: boolean = true;
  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  langs: any[] = [
    {
      id: 'ru',
      name: 'Русский'
    },
    {
      id: 'en',
      name: 'Английский'
    },
    {
      id: 'kk',
      name: 'Казахский'
    }
  ]

  @ViewChildren('element', { read: ElementRef })
  elements: QueryList<ElementRef>;


  form: UntypedFormGroup = this.fb.group({
    id: [null],
    org_id: [null],
    name: [null, this.validator.name],
    type: ["IN", this.validator.type],
    data: this.fb.array([]),
    deleted_mappings: [null]
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiAttrsMappingService: ApiAttributesMappingService,
    private notification: NotificationService,
    private validator: AttributesMappingActionsValidator,
    private validatorService: ValidatorsService,
    public activeModal: NgbActiveModal,
    private dialogModal: DialogModalService,
    public permissionAccess: PermissionService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    // this.addMappingFields();
    // this.getAttributes();
    this.getAttributeGroup();
    // this.getAttributesTypes();

    if (this.permissionAccess.check('REFERENCES_ORGANIZATIONS')) {
      this.getOrganizations();
    }

    this.subscriptions.add(
      this.apiAttrsMappingService.listenerAttrMappingData().subscribe(val => {

        if (val) {

          this.mappingId = val;
          this.onEdit(val);

        } else {

          // НА СЛУЧАЙ ЕСЛИ ИЗ ЛИСТА ПЕРЕЙТИ В РЕДАКТИРОВАНИЕ, ВЕРНУТСЯ В ЛИСТ БЕЗ ПРИМЕНЕНИЯ ИЗМЕНЕНИЙ(ПОСРЕДСТВОМ ПЕРЕКЛЮЧЕНИЕ ТАБОВ)
          // И СНОВА НАЖАТЬ НА "СОЗДАТЬ ШАБЛОН"
          // Чистка arrayForm с данными элементов маппинга
          this.form.get('id').setValue(null);
          let control = this.form.controls.data as UntypedFormArray;
          control.clear();
          control.updateValueAndValidity();

          // Обнуление переменной со наименованием маппинга
          this.mappingName = { ru: '', en: '', kk: '' };
        }

      })
    );

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventFnFF(fieldName: string, value: any): void {

    this.ffInputLang = value;

    this.form.controls[fieldName].setValue(value.name);
  }

  /**
   * 
   */
  getOrganizations(searchValue: string = ''): void {

    this.organizations = [];

    let data = {
      ref_name: 'organizations',
      filter: {
        name: searchValue,
        sort: 'all'
      }
    }

    this.subscriptions.add(
      this.apiAttrsMappingService.getReferences(data, data.ref_name).subscribe((response: Res) => {
        console.log('[RESPONSE] getOrganizations: ', response);

        if (response != null) {

          this.organizations = response.result;

        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   */
  getAttributesTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes_mapping_types',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiAttrsMappingService.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributePresetTypes = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  getAttributes(attribute_group_id: string, index: number): void {

    console.log("INDEX: ", index);


    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
        group_id: attribute_group_id
      }
    }

    this.subscriptions.add(
      this.apiAttrsMappingService.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRIBUTES LIST: ", response);


        if (response != null) {

          this.attributes[index] = response.result;

        }
      })
    );

  }

  /**
   * 
   */
  getAttributeGroup(): void {

    let params: ReferenceParams = {
      ref_name: 'attribute_groups',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiAttrsMappingService.getReferences(params, params.ref_name).subscribe((response: any) => {console.log("ATTR GROUPS: ", response);
      

        if (response != null) {

          this.attributeGroups = response.result;
        }
      })
    );

  }

  /**
   * 
   * @returns 
   */
  initMappingFields(): any {

    return this.fb.group({
      id: [null],
      attribute_id: [null, this.validator.attribute_id],
      attribute_group_id: [null, this.validator.attribute_group_id],
      foreign_attribute_id: [null, this.validator.foreign_attribute_id]
    });
  }

  /**
   * 
   * @param type string
   */
  addMappingFields(): void {

    let control = this.form.controls.data as UntypedFormArray;
    control.push(this.initMappingFields());

    setTimeout(() => this.elements.last.nativeElement.focus());

    // let index: number = (control.length - 1);

    // this.onAttributeSubsription(index);

  }

  /**
   * 
   * @param i number
   */
  removeMappingField(i: number): void {

    if (this.form.get(['data', i, 'id']).value != null) {

      this.deletedData.push(this.form.get(['data', i, 'id']).value)

      this.form.controls.deleted_mappings.setValue(this.deletedData);
    }

    let control = this.form.controls.data as UntypedFormArray;
    control.removeAt(i);

    // this.getAttributes(this.form.get(['data', i, 'attribute_group_id']).value, i);

    // this.onAttributeSubsription(i);


  }


  /**
   * 
   * @param index 
   */
  // onAttributeSubsription(index: number) {

  //   if (index > -1) {

  //     this.subscriptions.add(
  //       this.form.get(['data', index, 'attribute_group_id']).valueChanges.subscribe(value => {

  //         if (value) {

  //           this.getAttributes(value, index);
  //         }
  //       })
  //     );
  //   }
  // }

  /**
  * 
  */
  onListenerType(index: number) {

    let currentVal = this.form.get(['data', index, 'attribute_group_id']).value;

    if (currentVal) {

      this.getAttributes(currentVal, index);
    }
  }

  /**
   * 
   * @param file 
   */
  onFileDropped(file: FileData) {


    let data = {
      files: file,
      option: {
        multiple: this.multiple,
        component: this.component
      }
    }

    this.dialogModal.open(data, FileUploadProcessComponent).then(
      (response) => {

        if (response) {

          this.notification.show('success', 'Файл успешно загружен!');

          this.file = response.result;

          this.setFormData(response.result);

        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
   * 
   * @param fileData 
   */
  setFormData(fileData) {


    if (fileData != null) {

      fileData.forEach((element, index) => {

        this.addMappingFieldsWithdata(element, index);
      });
    }
  }

  /**
   * 
   */
  deleteFile() {

    this.form.get('file').setValue(null);
    this.file = null;
  }

  /**
   * 
   * 
   */
  addFilterFields(): void {

    let control = this.form.controls.data as UntypedFormArray;
    control.push(this.initFilterField(control.length));
  }

  /**
  * 
  * @param i number
  */
  removeFilterField(i: number): void {

    let control = this.form.controls.data as UntypedFormArray;
    control.removeAt(i);
  }

  /**
  * 
  * 
  */
  initFilterField(index: number): any {

    return this.fb.group({
      id: [null],
      attribute_id: [null, this.validator.attribute_id],
      attribute_group_id: [null, this.validator.attribute_group_id],
      foreign_attribute_id: [null, this.validator.foreign_attribute_id]
    });
  }

  /**
 * 
 * @param event 
 */
  onUploadedFile(event: any) {

    this.notification.show('success', 'Файл успешно загружен!');

    this.file = event.result;
    this.setFormData(event.result);



    console.log("RESULT: ", this.file);
  }

  /**
  * 
  */
  onEdit(id: string): void {

    this.progressRef.start();
    this.loading = true;
    let control = this.form.controls.data as UntypedFormArray;
    control.clear();

    this.subscriptions.add(

      this.apiAttrsMappingService.edit(id).subscribe((response: Res) => {
        console.log('[RESPONSE] MAPPING_EDIT_DATA: ', response);

        if (response != null) {

          this.setDataInForm(response.result);
          this.mappingData = response.result;

          if (this.organizations.length == 0) {
            this.organizations.push({ id: response.result.org_id, name: response.result.org_name })
          }

        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  /**
   * 
   * @param referenceData 
   */
  setDataInForm(mappingData) {

    this.mappingName = mappingData.name;

    this.form.patchValue({
      id: mappingData.id,
      org_id: mappingData.org_id,
      type: mappingData.type
    });

    if (this.mappingId) {

      this.form.get('org_id').disable();
    }

    if (mappingData.data != null) {

      mappingData.data.forEach((element, index) => {
        this.getAttributes(element.attribute_group_id, index);
        this.addMappingFieldsWithdata(element, index);
      });
    }
  }

  /**
   * 
   * @param type string
   */
  addMappingFieldsWithdata(mappingData: any, index: number): void {

    let control = this.form.controls.data as UntypedFormArray;
    control.push(this.setMappingData(mappingData));

    if (index > -1) {

      this.subscriptions.add(
        this.form.get(['data', index, 'attribute_group_id']).valueChanges.subscribe(value => {

          if (value) {

            this.getAttributes(value, index);
          }
        })
      );
    }
  }

  /**
   * 
   * @param referenceData 
   * @returns 
   */
  setMappingData(mappingData: any) {

    console.log("FILE: ", this.file);
    console.log("DATA: ", mappingData);


    return this.fb.group({
      id: mappingData.id,
      attribute_group_id: mappingData.attribute_group_id,
      attribute_id: mappingData.attribute_id,
      foreign_attribute_id: [this.file.length > 0 ? mappingData : mappingData.foreign_attribute_id]
    });
  }


  /**
   * 
   */
  onCreate(): void {

    let form = { ...this.form.value };

    this.progressRef.start();

    this.subscriptions.add(
      this.apiAttrsMappingService.create(form).subscribe((response: Res) => {
        console.log('[RESPONSE] saveMapping: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены');
          this.apiAttrsMappingService.setAttrMappingListsData(true);
          this.apiAttrsMappingService.switchTab('list');

          // Чистка arrayForm с данными элементов маппинга
          let control = this.form.controls.data as UntypedFormArray;
          control.clear();

          // Обнуление переменной со наименованием маппинга
          this.mappingName = { ru: '', en: '', kk: '' };
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value };

    this.progressRef.start();

    this.subscriptions.add(
      this.apiAttrsMappingService.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] UPDATE MAPPING: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.apiAttrsMappingService.setAttrMappingListsData(true);
          this.apiAttrsMappingService.switchTab('list');
          // this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
